var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2622_10220)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1235 6.3949L18.0547 12.1538C18.1095 12.1933 18.1541 12.2452 18.1849 12.3053C18.2156 12.3653 18.2317 12.4319 18.2317 12.4994C18.2317 12.5669 18.2156 12.6334 18.1849 12.6935C18.1541 12.7535 18.1095 12.8054 18.0547 12.8449L10.1235 18.6038C9.84223 18.8074 9.44581 18.6092 9.44581 18.2583V6.74044C9.44543 6.66157 9.46696 6.58414 9.508 6.51679C9.54904 6.44943 9.60797 6.3948 9.67824 6.35897C9.7485 6.32315 9.82733 6.30754 9.90595 6.31388C9.98456 6.32022 10.0599 6.34827 10.1235 6.3949ZM11.1547 9.25562V15.7431L15.6199 12.4994L11.1547 9.25562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 12.5C0.5 5.87321 5.87321 0.5 12.5 0.5C19.1268 0.5 24.5 5.87321 24.5 12.5C24.5 19.1268 19.1268 24.5 12.5 24.5C5.87321 24.5 0.5 19.1268 0.5 12.5ZM2.53571 12.5C2.53571 18.0018 6.99821 22.4643 12.5 22.4643C18.0018 22.4643 22.4643 18.0018 22.4643 12.5C22.4643 6.99821 18.0018 2.53571 12.5 2.53571C6.99821 2.53571 2.53571 6.99821 2.53571 12.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2622_10220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.18ea485b3e7ce6be1919920fdfc9629c.svg";
export { ForwardRef as ReactComponent };